import { ContentRow, Spacing } from 'components/ThemeComponents';
import { 
  Form,
  Input,
  Select,
  Card
} from 'antd';
import {
  validateMessages
} from 'helpers/validationHelper';
import { useEffect, useState, useCallback } from 'react';

const roleOptions = [
  { value: 'super_admin', label: 'Super Admin' },
  { value: 'sale', label: 'Sale' },
  { value: 'support', label: 'Support' }
];

export default function ManagerForm({ form, manager = {} }) {
  return (
    <ContentRow capped>
      <Form
        form={form}
        name="manager_form"
        layout="vertical"
        validateMessages={validateMessages}
        initialValues={manager}
      >
        <Card
          title={'Thông tin Manager'}
          style={{ 
            minWidth: '300px',
            width: '100%'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between'
            }}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, type: 'email' }]}
              style={{ width: '48%' }}
            >
              <Input placeholder="Nhập email" />
            </Form.Item>

            <Form.Item 
              label="Role"
              name="role"
              rules={[{ required: true }]}
              style={{ width: '48%' }}
            >
              <Select 
                options={roleOptions}
                placeholder="Chọn role"
              />
            </Form.Item>
          </div>
        </Card>
      </Form>
    </ContentRow>
  );
}
